import { jsx, jsxs } from 'react/jsx-runtime';
import { useEffect, useMemo } from 'react';
import { useLatestRef } from '@circlefin/hooks';
import * as Headlessui from '@headlessui/react';
import classNames from 'classnames';
import { Icon } from '../Icon/Icon.es.js';

const InlineNotification = ({ className, visible = true, intent, size = 'base', autoDismiss, locale = {
    label: 'Inline notification'
}, onDismiss = ()=>undefined, children, ...rest })=>{
    const onDismissLatestRef = useLatestRef(onDismiss);
    useEffect(()=>{
        if (!visible || !autoDismiss) {
            return;
        }
        // arbitrary timeout of 5s for dismiss. Option not given to ensure consistency.
        const timeout = setTimeout(onDismissLatestRef.current, 5000);
        return ()=>{
            if (timeout != null) {
                clearTimeout(timeout);
            }
        };
    }, [
        visible,
        autoDismiss,
        onDismissLatestRef
    ]);
    const iconName = useMemo(()=>{
        switch(intent){
            case 'success':
                return 'CheckCircleSolid';
            case 'warning':
                return 'ExclamationSolid';
            case 'error':
                return 'ExclamationCircleSolid';
            case 'neutral':
                return;
        }
    }, [
        intent
    ]);
    return jsx(Headlessui.Transition, {
        ...rest,
        "aria-label": locale.label,
        "aria-live": "assertive",
        as: "div",
        className: classNames('cb-inline-notification', className, size),
        enter: "transition ease-out duration-100",
        enterFrom: "transform opacity-0",
        enterTo: "transform opacity-100",
        leave: "transition ease-in duration-75",
        leaveFrom: "transform opacity-100",
        leaveTo: "transform opacity-0",
        show: visible,
        children: jsxs("div", {
            className: "content",
            children: [
                iconName && jsx(Icon, {
                    className: classNames('inline-notification-icon', intent),
                    name: iconName
                }),
                children
            ]
        })
    });
};

export { InlineNotification, InlineNotification as default };
//# sourceMappingURL=InlineNotification.es.js.map
